<script setup lang="ts">
import { useUrlHelper } from '@/page/infrastructure/composition/useUrlHelper';
import { ref, watch } from 'vue';

type Emits = {
  (e: 'getPosts'): void;
}

const model = defineModel<string>({ required: true });

const emit = defineEmits<Emits>();

const { getIaFQuoteUrl, getSmallBusinessQuoteUrl, getMedicareAppointmentUrl, getEnrollmentAppUri } = useUrlHelper();

const getPosts = (): void => {
  emit('getPosts');
};

const asideLinks = [
  { name: 'Health', link: getIaFQuoteUrl() },
  { name: 'Dental', link: getEnrollmentAppUri('/dental/quote') },
  { name: 'Vision', link: getEnrollmentAppUri('/vision/quote') },
  { name: 'Small Business', link: getSmallBusinessQuoteUrl() },
  { name: 'Medicare', link: getMedicareAppointmentUrl() },
];

const search = ref(model.value);

watch(search, value => model.value = value);

</script>

<template>
<aside class="flex flex-col gap-4 items-center md:items-start">
  <ul class="flex flex-col gap-1 md:ml-7">
    <li v-for="link in asideLinks" :key="link.name" class="text-center md:text-left">
      <a :href="link.link" class="hover:underline font-semibold text-blue-600 mr-1" target="_blank">
        {{ link.name }}
        <hfc-icon icon="arrow-circle-right" class="text-gray-50 bg-black rounded-full " />
      </a>
    </li>
  </ul>
  <form @submit.prevent class="w-full max-w-xs hidden md:flex">
    <input
      type="search"
      placeholder="Search..."
      v-model="search"
      class="w-full rounded-full px-2 py-0 h-10 bg-gray-50 font-semibold text-blue-700 shadow-md focus:outline-none rounded-r-none"
    />

    <button
      class="bg-blue-500 h-10 rounded-full rounded-l-none text-white px-4 shadow-md flex items-center justify-center"
      @click="getPosts"
    >
      <hfc-icon icon="search" class="text-white" />
    </button>
  </form>
</aside>
</template>
